Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tableForegroundColor: tokens.themeInkDefault,
    tableBackgroundColorDefault: tokens.themePageDefault,
    tableBackgroundColorHover: tokens.themeActionNeutralHover,
    tableBackgroundColorPressed: tokens.themeActionNeutralPressed,
    tableBackgroundColorHighlight: tokens.themePageHighlight,
    tableFontSizeNestedHeader: 14,
    tableFontSizeSectionHeader: 14,
    tableFontSizeBody: 12,
    tableFontSizeCaption: 14,
    tableFontWeightHeader: 600,
    tableFontWeightBody: 400,
    tableFontColorCaption: tokens.themeInkSubdued,
    tableBorderWidthHeader: 2,
    tableBorderWidthBody: 1,
    tableBorderRadius: 0,
    tableBorderColor: tokens.themeBorderDefault,
    tableActionBarOverlayBackgroundColorDefault: tokens.themeActionPrimaryDefault,
    tableActionBarOverlayBackgroundColorHover: tokens.themeActionPrimaryHover,
    tableActionBarOverlayBackgroundColorPressed: tokens.themeActionPrimaryPressed,
    tableActionBarOverlayForegroundColor: tokens.themeInkInverse,
    tableSortIndicatorColorDefault: tokens.themeInkSubdued,
    tableSortIndicatorColorHover: tokens.themeActionPrimaryHover,
    tableSortIndicatorColorFocus: tokens.themeActionPrimaryHover,
    tableSortIndicatorColorPressed: tokens.themeActionPrimaryPressed,
    tableSortIndicatorColorSorted: tokens.themeInkDefault,
    tableSortIndicatorWidth: 24,
    tableSortIndicatorHeight: 24,
    tableSortIndicatorSpacing: 4,
    tableSpacingHorizontal: 16,
    tableSpacingVerticalSmall: 8,
    tableSpacingVerticalMedium: 16,
    tableMotionDuration: "100ms",
    tableMotionFunction: "ease",
    tableOverflowFixedRowShadowOffsetX: 0,
    tableOverflowFixedRowShadowOffsetY: 8,
    tableOverflowFixedRowShadowBlur: 8,
    tableOverflowFixedRowShadowSpread: -4,
    tableOverflowFixedRowShadowColor: "#02080E",
    tableOverflowFixedRowShadowOpacity: 16,
    tableOverflowStickyRowShadowOffsetX: 0,
    tableOverflowStickyRowShadowOffsetY: 8,
    tableOverflowStickyRowShadowBlur: 8,
    tableOverflowStickyRowShadowSpread: 0,
    tableOverflowStickyRowShadowColor: "#02080E",
    tableOverflowStickyRowShadowOpacity: 16,
    tableOverflowStickyColumnShadowOffsetY: 0,
    tableOverflowStickyColumnShadowOffsetX: 8,
    tableOverflowStickyColumnShadowBlur: 8,
    tableOverflowStickyColumnShadowSpread: 0,
    tableOverflowStickyColumnShadowColor: "#02080E",
    tableOverflowStickyColumnShadowOpacity: 16
  }
};